class Hotspots extends HTMLElement {
  constructor() {
    super();
    const allHotspots = this.querySelectorAll('.hotspot');

    this.slider = this.querySelector('[id^="Slider-"]');

    allHotspots.forEach((hotspot) => {
      hotspot.addEventListener('click', () => {

        // Slide to Correct Slide
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

        let step = parseInt(hotspot.dataset.slide) - 1;

        this.slideScrollPosition = this.sliderItemsToShow[step].offsetLeft;
        this.slider.scrollTo({
          left: this.slideScrollPosition
        });

        // Change Active Hotspot
        hotspot.classList.add('is-active');

        allHotspots.forEach((inactiveLink) => {
          if(inactiveLink != hotspot){
            inactiveLink.classList.remove('is-active');
          }
        });

      })
    });

  }

}

customElements.define('hot-spots', Hotspots);